import React, { useState, ChangeEvent, useEffect, useRef } from 'react';
import { Button, Box, FormHelperText, Avatar, Stack, Typography, SxProps } from '@mui/material';
import { t } from 'i18next';

interface Iprops {
  name: string;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  error: string | undefined;
  isTouched: boolean | undefined;
  value?: string | File;
  sx?: SxProps;
  onReset?: (callback: () => void) => void;
}

const ImageUploader = (props: Iprops) => {
  const [imageUrl, setImageUrl] = useState<string>('');
  const [errorMeassage, setErrorMeassage] = useState<string>('');
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setErrorMeassage(`${t('Components.ImageUploader.fileSize')}`);

        return;
      }
      const url = URL.createObjectURL(file);

      setImageUrl(url);
      props.setFieldValue(props.name, file);
      setErrorMeassage('');
    }
  };

  const handleReset = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setImageUrl('');
    props.setFieldValue(props.name, '');
  };

  useEffect(() => {
    if (props.value && typeof props.value === 'string') {
      setImageUrl(props.value);
    } else if (props.value && props.value instanceof File) {
      const url = URL.createObjectURL(props.value);
      setImageUrl(url);
    }
  }, [props.value]);

  return (
    <Box>
      <Box textAlign="center" display="flex" justifyContent="center">
        <Box>
          <Avatar
            src={imageUrl}
            alt={imageUrl}
            sx={{ width: 120, height: 120, margin: '0 auto', ...props.sx }}
          />
          <Stack direction="row" justifyContent="center" spacing={2} my={3}>
            <Button variant="contained" color="primary" component="label">
              {t('Components.ImageUploader.upload')}
              <input
                ref={fileInputRef}
                onChange={handleFileChange}
                hidden
                accept="image/*"
                type="file"
              />
            </Button>
            <Button
              onClick={() => {
                if (props.onReset && typeof props.value === 'string') {
                  props.onReset(() => {
                    handleReset();
                  });

                  return;
                }
                handleReset();
              }}
              variant="outlined"
              color="error"
            >
              {t('Components.ImageUploader.reset')}
            </Button>
          </Stack>
        </Box>
      </Box>

      {errorMeassage ||
        (props.isTouched && props.error && (
          <FormHelperText error id="standard-weight-helper-text-email-login">
            {' '}
            {props.isTouched && props.error ? props.error : errorMeassage}{' '}
          </FormHelperText>
        ))}
    </Box>
  );
};

export default ImageUploader;
